import { z } from 'zod'

export const planLimitsSchema = z.object({
  plansPerMonth: z.number().int(),
  stopsPerPlan: z.number().int(),
  aiCallsPerMonth: z.number().int(),
  collaborators: z.number().int(),
  storageGB: z.number()
})

export const subscriptionPlanSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  tier: z.enum(['free', 'premium', 'pro']),
  description: z.string().optional(),
  monthlyPrice: z.number().min(0),
  currency: z.string().min(1).default('eur'),
  billingInterval: z.enum(['monthly', 'annual']),
  stripeProductId: z.string().optional().nullable(),
  stripePriceId: z.string().optional().nullable(),
  features: z.array(z.string()),
  limits: planLimitsSchema,
  highlight: z.string().optional(),
  badge: z.string().optional(),
  discountMonths: z.number().int().optional(),
  active: z.boolean().default(true),
  displayOrder: z.number().int().default(0),
  createdAt: z.string(),
  updatedAt: z.string()
})

export const createBillingPlanSchema = subscriptionPlanSchema.partial({
  createdAt: true,
  updatedAt: true,
  displayOrder: true,
  stripeProductId: true,
  stripePriceId: true
}).extend({
  id: z.string().min(1)
})

export const updateBillingPlanSchema = subscriptionPlanSchema.partial({
  id: true,
  createdAt: true
}).extend({
  updatedAt: z.string()
})

export const checkoutSessionSchema = z.object({
  planId: z.string().min(1),
  billing: z.enum(['monthly', 'annual']).default('monthly'),
  successUrl: z.string().url().optional(),
  cancelUrl: z.string().url().optional()
})

export const portalSessionSchema = z.object({
  returnUrl: z.string().url().optional()
})

export const billingWebhookHeadersSchema = z.object({
  'stripe-signature': z.string().min(1)
})

export const referralCodeSchema = z.object({
  code: z.string().min(4),
  rewardReferrer: z.string().min(1),
  rewardReferred: z.string().min(1)
})

export const qualifyReferralSchema = z.object({
  userId: z.string().min(1),
  reason: z.string().min(1).default('subscription_bonus'),
  invoiceId: z.string().optional()
})

export const billingMetricsQuerySchema = z.object({
  month: z.string().optional(),
  year: z.string().optional()
})
